import { FC } from 'react'

export type IconName = 'envelope' | 'bbbLogo' | 'paypal'

export type IconType = React.DetailedHTMLProps<
  React.HTMLAttributes<SVGSVGElement>,
  SVGSVGElement
> & {
  name: IconName
  width?: number
  height?: number
  fill?: string
  fill2?: string
  className?: string
}

const Icon: FC<IconType> = ({
  className,
  fill,
  fill2,
  height,
  name,
  width,
  ...rest
}) => {
  switch (name) {
    case 'envelope':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={36}
          height={37}
          fill='none'
          {...rest}
        >
          <g clipPath='url(#a)' opacity={0.6}>
            <path
              fill='#fff'
              d='M6.787 8.15a2.588 2.588 0 0 0-1.552 4.657l11.73 8.798a1.73 1.73 0 0 0 2.07 0l11.73-8.798a2.589 2.589 0 0 0-1.553-4.657H6.788ZM4.2 14.187V25.4a3.453 3.453 0 0 0 3.45 3.45h20.7a3.453 3.453 0 0 0 3.45-3.45V14.188l-11.73 8.797a3.445 3.445 0 0 1-4.14 0L4.2 14.188Z'
            />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='#fff' d='M4.2 4.7h27.6v27.6H4.2z' />
            </clipPath>
          </defs>
        </svg>
      )
    case 'bbbLogo':
      return (
        <svg
          width={width || '28'}
          height={height || '30'}
          viewBox='0 0 28 30'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          {...rest}
        >
          <path
            d='M23.4892 14.8333L23.4476 14.8125C25.0163 13.2847 25.8007 11.4236 25.8007 9.22917C25.8007 7.14583 25.0233 5.34028 23.4684 3.8125C21.9275 2.27083 20.1019 1.5 17.9918 1.5H1.49931V30H0V0H17.9918C19.6299 0 21.1639 0.423611 22.5938 1.27083C24.0376 2.10417 25.1829 3.23611 26.0297 4.66667C26.8766 6.08333 27.3 7.60417 27.3 9.22917C27.3 11.4514 26.703 13.3611 25.5092 14.9583C26.703 16.6111 27.3 18.4306 27.3 20.4167C27.3 22.3194 26.8696 24 26.0089 25.4583C25.1482 26.9028 24.0168 27.9931 22.6146 28.7292C21.2264 29.4653 19.6854 29.8333 17.9918 29.8333H8.51693V28.3333H17.9918C20.1297 28.3333 21.9622 27.5764 23.4892 26.0625C25.0302 24.5347 25.8007 22.6528 25.8007 20.4167C25.8007 19.3889 25.5786 18.375 25.1343 17.375C24.6901 16.375 24.1348 15.5347 23.4684 14.8542C23.4684 14.8403 23.4754 14.8333 23.4892 14.8333ZM17.9918 22.3333H8.51693V23.8333H17.9918C18.908 23.8333 19.6854 23.5278 20.324 22.9167C20.9765 22.2917 21.3027 21.4583 21.3027 20.4167C21.3027 19.5139 20.9696 18.7222 20.3032 18.0417C19.6368 17.3472 18.8664 17 17.9918 17H8.49611V18.5H17.9918C18.4638 18.5 18.8802 18.6944 19.2412 19.0833C19.616 19.4722 19.8034 19.9167 19.8034 20.4167C19.8034 21.0278 19.6299 21.5 19.2828 21.8333C18.9358 22.1667 18.5054 22.3333 17.9918 22.3333ZM17.9918 25.3333H8.51693V26.8333H17.9918C19.7132 26.8333 21.1917 26.2222 22.4272 25C23.6767 23.7639 24.3014 22.2361 24.3014 20.4167C24.3014 19.2639 23.989 18.1806 23.3643 17.1667C22.7535 16.1389 21.9413 15.3472 20.9279 14.7917C21.9413 14.2639 22.7535 13.5139 23.3643 12.5417C23.989 11.5556 24.3014 10.4514 24.3014 9.22917C24.3014 7.5625 23.6697 6.11111 22.4064 4.875C21.157 3.625 19.6854 3 17.9918 3H2.99863V30H4.49794V4.5H17.9918C19.269 4.5 20.3865 4.97917 21.3444 5.9375C22.3162 6.88194 22.8021 7.97917 22.8021 9.22917C22.8021 10.6181 22.3301 11.7639 21.386 12.6667C20.442 13.5556 19.3106 14 17.9918 14H8.51693V15.5H17.9918C19.269 15.5 20.3865 15.9931 21.3444 16.9792C22.3162 17.9653 22.8021 19.1111 22.8021 20.4167C22.8021 21.8611 22.3301 23.0417 21.386 23.9583C20.442 24.875 19.3106 25.3333 17.9918 25.3333ZM17.9918 11H8.51693V12.5H17.9918C18.9219 12.5 19.7063 12.2083 20.3448 11.625C20.9834 11.0278 21.3027 10.2292 21.3027 9.22917C21.3027 8.38194 20.9696 7.63194 20.3032 6.97917C19.6368 6.32639 18.8664 6 17.9918 6H5.99725V30H7.49657V7.5H17.9918C18.4638 7.5 18.8802 7.68055 19.2412 8.04167C19.616 8.38889 19.8034 8.78472 19.8034 9.22917C19.8034 9.79861 19.6299 10.2361 19.2828 10.5417C18.9358 10.8472 18.5054 11 17.9918 11Z'
            fill='url(#paint0_linear_5071_29168)'
          />
          <defs>
            <linearGradient
              id='paint0_linear_5071_29168'
              x1='26.637'
              y1='0.556038'
              x2='26.637'
              y2='31.5059'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='#89E6E3' />
              <stop offset='0.505208' stopColor='#FFF7AE' />
              <stop offset='1' stopColor='#FF6392' />
            </linearGradient>
          </defs>
        </svg>
      )
    case 'paypal':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={width || '86'}
          height={height || '23'}
          fill='none'
          viewBox='0 0 86 23'
        >
          <path
            fill={fill || '#D9D9D9'}
            fillRule='evenodd'
            d='M10.332 0H3.635a.93.93 0 00-.92.783L.008 17.89a.556.556 0 00.552.642h3.198a.93.93 0 00.92-.783l.73-4.614a.928.928 0 01.918-.784h2.12c4.412 0 6.958-2.127 7.623-6.34.3-1.844.012-3.293-.854-4.308C14.262.59 12.574 0 10.332 0zm.773 6.248c-.367 2.394-2.203 2.394-3.978 2.394h-1.01l.708-4.47a.557.557 0 01.552-.47h.463c1.21 0 2.35 0 2.94.687.351.41.459 1.018.325 1.86zM30.522 6.042h-3.207a.558.558 0 00-.551.47l-.142.893-.224-.324c-.695-1.004-2.243-1.34-3.788-1.34-3.544 0-6.571 2.674-7.16 6.425-.307 1.871.129 3.66 1.194 4.908.978 1.147 2.376 1.625 4.04 1.625 2.855 0 4.438-1.829 4.438-1.829l-.142.888a.557.557 0 00.55.644h2.889a.93.93 0 00.92-.784L31.07 6.685a.554.554 0 00-.549-.642zm-4.47 6.218c-.31 1.825-1.764 3.05-3.619 3.05-.93 0-1.675-.297-2.153-.86-.474-.56-.654-1.358-.503-2.246.289-1.81 1.767-3.075 3.594-3.075.91 0 1.65.302 2.138.87.489.575.683 1.377.543 2.261zM47.355 6.316h-3.223a.934.934 0 00-.77.407l-4.445 6.522-1.884-6.268a.933.933 0 00-.893-.661h-3.167a.557.557 0 00-.53.735l3.55 10.378-3.337 4.693a.556.556 0 00.455.878h3.219a.93.93 0 00.765-.398L47.813 7.19a.556.556 0 00-.458-.873z'
            clipRule='evenodd'
          ></path>
          <path
            fill={fill || '#fff'}
            fillRule='evenodd'
            d='M58.099 0H51.4a.93.93 0 00-.919.783L47.775 17.89a.556.556 0 00.55.642h3.438a.65.65 0 00.642-.548l.768-4.85a.929.929 0 01.919-.783h2.12c4.411 0 6.956-2.127 7.623-6.34.3-1.844.011-3.293-.855-4.308C62.028.59 60.34 0 58.099 0zm.773 6.248c-.366 2.394-2.202 2.394-3.978 2.394h-1.01l.71-4.47a.555.555 0 01.55-.47h.464c1.208 0 2.35 0 2.94.687.351.41.458 1.018.324 1.86zM78.284 6.042H75.08a.555.555 0 00-.55.47l-.142.893-.225-.324c-.695-1.004-2.242-1.34-3.787-1.34-3.544 0-6.57 2.674-7.16 6.425-.305 1.871.129 3.66 1.194 4.908.98 1.147 2.376 1.625 4.04 1.625 2.855 0 4.439-1.829 4.439-1.829l-.143.888a.557.557 0 00.552.644h2.888a.93.93 0 00.918-.784l1.734-10.934a.558.558 0 00-.553-.642zm-4.47 6.218c-.307 1.825-1.764 3.05-3.618 3.05-.93 0-1.676-.297-2.154-.86-.474-.56-.652-1.358-.503-2.246.29-1.81 1.767-3.075 3.594-3.075.91 0 1.65.302 2.138.87.49.575.685 1.377.543 2.261zM81.798.47l-2.749 17.421a.556.556 0 00.55.642h2.764c.46 0 .849-.332.92-.783L85.992.643a.556.556 0 00-.55-.643h-3.095c-.273 0-.508.2-.55.47z'
            clipRule='evenodd'
          ></path>
        </svg>
      )

    default:
      return null
  }
}

export default Icon
